import { Injectable } from '@angular/core';
import { idNameItem, jkLib, jkRestReturn, OpenWinLoadOption } from 'jk-service';
import { AxiosRequestConfig } from 'axios';
import { StkmbServicePkg } from './stkmbPkg.service';

@Injectable({
  providedIn: 'root'
})
export class StkmbService extends StkmbServicePkg {
  uId: string = '';
  accountList: idNameItem[] = [];
  futureAccountList: idNameItem[] = [];
  seaAccountList: idNameItem[] = [];
  seaSelectAccountList: idNameItem[] = [];
  constructor() {
    super();
    this.getIdNameList();
  }
  getIdNameList() {
    let r: OpenWinLoadOption = {
      mainTable: 'STKMB',
      item: 'S01',
      type: 'S',
      params: [this.userId],
      list: this.idNameList,
    };
    this.orm.doOpenwinLoadRx(r).subscribe({
      next: (value) => {
        this.idNameList = value.obj;
      },
      error: (error) => {
        alert(this.tableName + ' 載入錯誤:' + error.message);
      },
      complete: () => {
        if(this.idNameList){
          this.accountList = this.idNameList.filter((item) => item.ps2 === 'TS');//台股票
          this.futureAccountList = this.idNameList.filter((item) => item.ps2 === 'TF');//台期
          this.seaAccountList = this.idNameList.filter((item) => item.ps2 === 'OF');//海期
          this.seaSelectAccountList = this.idNameList.filter((item) => item.ps2 === 'OS');//台股票
          this.uId = this.getCapitalUid();
        }
      }
    });
    //return this.idNameList;
  }

  async importStkmj(date: string,ret:jkRestReturn): Promise<void> {
     // http://localhost:9086/stock/stkmeImportStkmj?date=20240903
    let config: AxiosRequestConfig = jkLib.axiosConfigInit(
      this.host,
      `/stock/stkmeImportStkmj?date=${date}`,
      'get',
      '',
      undefined
    );

    let bool = await this.doAxios(config, ret);

  }
  private getCapitalUid(): string {
    if (!this.accountList) return '';
    if(this.accountList.length === 0) return '';
    return jkLib.fixString(this.accountList[0].ps1);
  }
}

